<template>
    <div>
        <a-drawer
            :title='title'
            :visible="visible"
            v-bind="drawerConfig"
            :body-style="{ paddingBottom: '80px' }"
            @close="onClose">
            <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout">
                <a-form-model-item
                    ref="name"
                    label="版本名称"
                    prop="name"
                    :help="formErr.name"
                    :validateStatus='!formErr.name || formErr.name === "" ? "" : "error"'>
                    <a-input
                        :maxLength=80
                        v-model="form.name"
                        @change="(e) => { formErr.name=''}"
                        @blur="(e) => {  form.name = e.target.value.trim() }"/>
                </a-form-model-item>
                <a-form-model-item
                    ref="abstract"
                    label="描述"
                    prop="abstract"
                    :help="formErr.abstract"
                    :validateStatus='!formErr.abstract || formErr.abstract === "" ? "" : "error"'>
                    <a-textarea :maxLength=200 :rows="4" v-model="form.abstract"
                                @change="(e) => { formErr.abstract=''}"
                                @blur="(e) => {  form.abstract = e.target.value.trim() }"/>
                </a-form-model-item>
                <a-form-model-item
                    ref="status"
                    label="状态"
                    prop="status"
                    :extra="formErr.status"
                    :validateStatus='!formErr.status || formErr.status === "" ? "" : "error"'>
                    <a-radio-group v-model="form.status">
                        <a-radio :value="1"> 启用</a-radio>
                        <a-radio :value="0"> 停用</a-radio>
                    </a-radio-group>
                </a-form-model-item>
                <a-form-model-item
                    ref="business_opportunity_status"
                    label="谷歌商机条数"
                    prop="business_opportunity_status"
                    :extra="formErr.business_opportunity_status"
                    :validateStatus='!formErr.business_opportunity_status || formErr.business_opportunity_status === "" ? "" : "error"'>
                    <a-radio-group v-model="form.business_opportunity_status">
                        <a-radio :value="1"> 显示</a-radio>
                        <a-radio :value="2"> 隐藏</a-radio>
                    </a-radio-group>
                </a-form-model-item>
            </a-form-model>
            <div class="drawer-btn">
                <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
                    确定
                </a-button>
                <a-button @click="onClose">
                    取消
                </a-button>
            </div>
        </a-drawer>
    </div>
</template>

<script>
import {submitForm, drawerConfig, validator} from "@/utils/utils"
import API from "../api";
export default {
    name: "serverForm",
    props: ["visible", "title", "editId"],
    data() {
        return {
            drawerConfig,
            role: [],
            form: {
                name: "",
                abstract: "",
                status: 1,
                business_opportunity_status: 1,
            },
            formErr: {
                name: "",
                abstract: "",
                status: "",
                business_opportunity_status: ""
            },
            rules: {
                name: [{required: true, message: "请输入版本名称 ",}, {
                    whitespace: true,
                    message: "请输入版本名称 "
                }, {
                    validator: (rule, value, callback) => {
                        validator(rule, value, callback, this.formErr.name)
                    }, trigger: "blur"
                },],

            },
            layout: {
                labelCol: {span: 4},
                wrapperCol: {span: 14},
            },
        };
    },
    watch: {
        editId: function (a, b) {
            if (a != "") {
                API.versionManagement.EDIT_DATA(a).then(res => {
                    let val = res.data.data.info
                    this.form.id = a
                    this.form = val
                })
            } else {
                this.form.id = ''
            }
        }
    },
    mounted() {
    },
    methods: {
        onClose() {
            this.$emit("changVisible", false);
            this.form.password = "";
            this.formErr = {name: "", abstract: "", status: "", business_opportunity_status: ""};
            this.$refs.ruleForm.resetFields();
        },
        onSubmit() {
            let _this = this;
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    let url
                    this.form.id == '' || this.form.id == undefined ? url = API.versionManagement.SUBMIT_ADD : url = API.versionManagement.SUBMIT_EDIT
                    submitForm(url, _this.form).then(res => {
                        if (res == true) {
                            this.onClose()
                        } else {
                            res.map((item, index) => {
                                this.formErr[item.field] = item.msg
                            })
                        }
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
    },
}
</script>

<style scoped>

</style>
